import { useState } from "react";
import RegisterAccess from "../../utils/registerAccess";
import FichaAdmin from "./fichaAdmin";
// import { format, parseISO } from 'date-fns';

export default function InformacaoAdmin(props) {
    const [update, setUpdate] = useState(false);

  return (
    <>
      <RegisterAccess page={"Informação de admin"} />

      <br />
      <FichaAdmin admin={props.admin} local={'perfilAdmin'} setHandleUpdate={setUpdate} />
    </>
  );
}
